/* DreamWave: stops obvious fake, throwaway and mistyped emails on every sign-up form
   (pop-up and footer) before they reach Shopify. Runs before the forms' own handlers.
   This cannot prove an inbox is real: the double opt-in confirmation email does that. */
(function () {
  if (window.dwEmailCheck) return;
  window.dwEmailCheck = true;

  var THROWAWAY = ('mailinator.com guerrillamail.com guerrillamail.net sharklasers.com grr.la 10minutemail.com 10minutemail.net ' +
    'tempmail.com temp-mail.org temp-mail.io tempmail.net tempmailo.com tempail.com tempr.email yopmail.com yopmail.net ' +
    'trashmail.com trashmail.de getnada.com nada.email dispostable.com maildrop.cc throwawaymail.com fakeinbox.com ' +
    'mintemail.com emailondeck.com mohmal.com burnermail.io spamgourmet.com mailnesia.com moakt.com discard.email ' +
    'mailcatch.com getairmail.com spambox.us mytemp.email inboxkitten.com emailfake.com fakemail.net tmpmail.org ' +
    'tmail.ws mail.tm 1secmail.com 1secmail.net mailpoof.com byom.de').split(' ');
  var FAKE_DOMAINS = 'example.com example.org example.net test.com test.ca test.org asdf.com qwerty.com fake.com abc.com aaa.com email.test none.com no.com'.split(' ');
  var FAKE_NAMES = /^(test|testing|tester|asdf+|qwerty|fake|none|noemail|no|na|n\/a|abc|abcd|aaa+|xxx+|sdf+|jkl|hello|hi|null|undefined|nobody|someone|random|email|mail|me|user|admin)\d*$/i;
  var TYPOS = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com',
    'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmaill.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmali.com': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoo.con': 'yahoo.com', 'yhoo.com': 'yahoo.com',
    'outlok.com': 'outlook.com', 'outllook.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com',
    'iclod.com': 'icloud.com', 'icloud.co': 'icloud.com', 'icoud.com': 'icloud.com', 'icloud.con': 'icloud.com',
    'shaw.co': 'shaw.ca', 'telus.com': 'telus.net', 'rogers.co': 'rogers.com', 'sympatico.com': 'sympatico.ca'
  };
  var SHAPE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;

  function problem(value) {
    var email = value.trim().toLowerCase();
    if (!SHAPE.test(email)) return 'Please enter a valid email address, like name@example.com.';
    var parts = email.split('@'), name = parts[0], domain = parts[1];
    if (TYPOS[domain]) return 'Did you mean ' + name + '@' + TYPOS[domain] + '? Please check your email address.';
    if (THROWAWAY.indexOf(domain) !== -1) return 'Please use your personal email. Temporary inboxes can\'t receive your code.';
    if (FAKE_DOMAINS.indexOf(domain) !== -1 || FAKE_NAMES.test(name) || /^(.)\1{3,}$/.test(name)) return 'Please enter your real email address. We\'ll send your code there.';
    return '';
  }

  function show(form, input, message) {
    input.setAttribute('aria-invalid', 'true');
    var box = form.querySelector('[data-dw-pop-error]') || form.querySelector('.dw-email-check');
    if (!box) {
      box = document.createElement('p');
      box.className = 'dw-email-check';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:8px 0 0;font-size:14px;font-weight:500;color:#e5484d;';
      (input.closest('.dw-foot__form') || input).insertAdjacentElement('afterend', box);
    }
    box.textContent = message;
    box.hidden = false;
    input.focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var input = form && form.querySelector ? form.querySelector('input[name="contact[email]"]') : null;
    if (!input) return;
    var message = problem(input.value);
    if (!message) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    show(form, input, message);
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || input.name !== 'contact[email]') return;
    var box = input.form && input.form.querySelector('.dw-email-check');
    if (box) box.hidden = true;
  });
})();
